import { render, staticRenderFns } from "./CategoryGoods.vue?vue&type=template&id=785c86a2&"
import script from "./CategoryGoods.vue?vue&type=script&lang=js&"
export * from "./CategoryGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports